export default __webpack_public_path__ + "static/media/success-light.6030138b.svg";